import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        {
          text: 'نام و نام خانوادگی',
          value: 'fullName',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'شماره پرسنلی',
          value: 'personalNumber',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'زمان شروع',
          value: 'startDate',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'زمان پایان',
          value: 'endDate',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'مدت زمان',
          value: 'duration',
          align: 'center',
          isGroupable: true,
        },
        { text: 'علت', value: 'note', align: 'center', isGroupable: true },
      ],
      tableItems: [],
      searchFromDate: '',
      searchToDate: '',
      searchUserId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let startDate = '-';
        let endDate = '-';
        let fullName = '';
        let duration = '';
        if (data[i].startDate) {
          startDate = Vue.moment(data[i].startDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].endDate) {
          endDate = Vue.moment(data[i].endDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].startDate && data[i].endDate) {
          // duration = Math.abs(data[i].endDate - data[i].startDate);
          duration = new Date(data[i].endDate).getTime() - new Date(data[i].startDate).getTime();
        }
        if (data[i].user) {
          let fName = data[i].user.firstName;
          let lName = data[i].user.lastName;
          fullName = fName + ' ' + lName;
        } else {
          fullName = '-';
        }
        this.tableItems.push({
          fullName: fullName,
          startDate: startDate,
          endDate: endDate,
          personalNumber:
            data[i].user && data[i].user.personnelNumber ? data[i].user.personnelNumber : '-',
          note: data[i].note ? data[i].note : '-',
          duration: this.msToTime(duration),
        });
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getUsersDNDsWithPaginationFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchUserId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getUsersDNDsWithPaginationFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchUserId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
};
